import { createAction, props } from '@ngrx/store';
import { DynamicRoutingStatistics } from '../../dynamic-routing.model';

export const setDynamicRoutingStatisticsAction = createAction(
  '[Dynamic Routing Statistics] set',
  props<{ dynamic_routing_statistics: DynamicRoutingStatistics }>()
);

export const clearDynamicRoutingStatisticsAction = createAction(
  '[Dynamic Routing Statistics] clear'
);
